import { Smush } from "../../../types/helpers";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../../types/prodcatBaseTypes";
import { Product, Variant } from "../../../types/types";

export const generatePromotionClassifications = (
  product: Smush<Product>,
  selectedVariant: Variant,
) => {
  const { messaging: messages = [] } = product;
  const { messaging: selectedVariantMessages = [] } = selectedVariant;

  const isPromotionalMessage = (
    message: NonPromotionalMessage | PromotionalMessage,
  ): message is PromotionalMessage => {
    return (message as PromotionalMessage).promotionGroup !== undefined;
  };

  const promotionalMessages = [
    ...messages,
    ...selectedVariantMessages,
  ].filter<PromotionalMessage>(isPromotionalMessage);

  const uniquePromotionalMessages = promotionalMessages.filter(
    (message, index, array) => {
      const isFirstWithTitle =
        index ===
        array.findIndex((otherMessage) => otherMessage.title === message.title);
      return isFirstWithTitle;
    },
  );

  const promotionClassifications = uniquePromotionalMessages.map((message) => ({
    group: message.promotionGroup,
    type: message.promotionType,
  }));
  return promotionClassifications;
};
